<template lang="pug">
div
  v-img.d-flex.justify-center.py-6(
    src="/img/header.jpg",
    gradient="to right, rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.1)",
    cover
  )
    router-link.h-100.white--text.pa-4(to="/")
      img.main-header-mobile-logo.w-100(:src="logo", contain, height="100%")
  .primary.d-flex.justify-center.flex-wrap
    v-btn.menu-button.font-weight-bold.text-none.white--text(
      v-for="({ name, path }, i) in menu",
      :key="i",
      :to="path",
      color="primary",
      height="63px",
      tile,
      depressed
    ) {{ name }}
</template>

<script>
import { getWhatsappLinkFromPhone } from "@/components/utils";

export default {
  props: {
    menu: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    logo() {
      return this.files + this.$rest("informations").item.img;
    },
    whatsappLink() {
      return getWhatsappLinkFromPhone(
        this.$rest("informations").item.whatsapp || ""
      );
    },
  },
  data() {
    return {
      current: this.$route.path,
      drawer: false,
    };
  },
};
</script>


<style>
.main-header-mobile-logo {
  max-width: 90vw;
}
.menu-button {
  font-size: 16px !important;
}
@media screen and (max-width: 418px) {
  .menu-button {
    height: 48px !important;
    font-size: 14px !important;
    padding: 0 8px !important;
  }
}
</style>